<script lang="ts">
  import SectionTitle from "@kontextwerk/web-sdk/ui/typography/SectionTitle.svelte"
  import type {
    HomeDashboardCommunicationPoint,
    HomeDashboardWorkOrderStatusShare,
  } from "../../../../../../../../../../api/kehrblatt/home-dashboard"
  import CommunicationBarsChart from "./_modules/communication-bars-chart"
  import WorkOrderStatusPieChart from "./_modules/work-order-status-pie-chart"

  const {
    communicationPoints,
    workOrderStatusShare,
    showAppointmentStatistics = true,
    showOrderStatistics = true,
  }: {
    communicationPoints: HomeDashboardCommunicationPoint[]
    workOrderStatusShare: HomeDashboardWorkOrderStatusShare[]
    showAppointmentStatistics?: boolean
    showOrderStatistics?: boolean
  } = $props()

  const sectionTitle = $derived(
    showAppointmentStatistics && showOrderStatistics
      ? "Termin- & Auftragsstatistiken"
      : showAppointmentStatistics
        ? "Terminstatistiken"
        : "Auftragsstatistiken",
  )
</script>

<section class="home-dashboard-section">
  <SectionTitle title={sectionTitle} brightBackground={true} small={true} />
  <div
    class:stats-grid--single={!showAppointmentStatistics || !showOrderStatistics}
    class="stats-grid"
  >
    {#if showAppointmentStatistics}
      <CommunicationBarsChart points={communicationPoints} />
    {/if}
    {#if showOrderStatistics}
      <WorkOrderStatusPieChart rows={workOrderStatusShare} />
    {/if}
  </div>
</section>

<style lang="less">
  .home-dashboard-section {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .stats-grid {
    display: grid;
    grid-template-columns: minmax(0, 1.2fr) minmax(260px, 0.8fr);
    gap: 0.75rem;
  }

  .stats-grid--single {
    grid-template-columns: minmax(0, 1fr);
  }

  @media (max-width: 900px) {
    .stats-grid {
      grid-template-columns: 1fr;
    }
  }
</style>
